import type { MyExperimentsResponse } from 'src/openapi';
import { formatToFetchError } from 'src/helpers/utils';
import apiClient from 'src/helpers/apiClient';
import appApi from './index';

const experimentsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    // The signed-in user's arm in every running user experiment. Stored server
    // side on first sight, so it is the same on every device; fetched once a
    // session, since an arm never changes under a user. Keyed by user id, so a
    // second account signing in on the same browser never reads the first's.
    getMyExperiments: build.query<MyExperimentsResponse, string>({
      queryFn: async () => {
        try {
          const { data } = await (
            await apiClient.getExperimentApi()
          ).experimentApiMyExperiments();
          return { data };
        } catch (err: any) {
          return formatToFetchError(err);
        }
      },
      keepUnusedDataFor: 60 * 60,
    }),
  }),
});

export const { useGetMyExperimentsQuery } = experimentsApi;

export default experimentsApi;
